import { TreeItem } from '../TreeItem/TreeItem';
/**
 * The `FlatTreeItem` component represents a single item in a flat tree.
 */ export const FlatTreeItem = TreeItem;
